<template>
  <transition name="spring" mode="out-in" appear>
    <div id="js-popup-menu" class="popup-menu">
      <UserCard :user-avatar="user.avatar" />

      <MenuItems />
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import UserCard from '../PopupMenuContent/UserCard';
import MenuItems from '../PopupMenuContent/MenuItems';
import handleClickoutside from '../../utils/handleClickOutside';

export default {
  name: 'PopupMenu',
  components: {
    UserCard,
    MenuItems
  },

  computed: {
    ...mapGetters({
      menuOpen: 'menu/isMenuOpen',
      user: 'app/user'
    })
  },

  mounted: function () {
    document.addEventListener('mouseup', this.closeOnClickOutside);
  },

  beforeDestroy: function () {
    document.removeEventListener('mouseup', this.closeOnClickOutside);
  },

  methods: {
    closeOnClickOutside(e) {
      const menu = document.getElementById('js-popup-menu');
      const menuToggle = document.getElementById('js-popup-toggle');
      handleClickoutside({
        event: e,
        elements: [menu, menuToggle],
        action: 'menu/closeMenu'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.popup-menu {
  // Grey background behind the cards, like the app; scrolls when the menu is
  // taller than the window.
  background-color: var(--Surface-Subtle);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 96px);
  border-top: 0;
  border-radius: 10px;
  box-shadow: 0px 0px 35px rgb(0 0 0 / 15%);
  overflow: hidden;
  left: calc(100% - 20px);
  position: absolute;
  top: 76px;
  transform: translateX(-100%);
  width: 340px;
  user-select: none;

  @media ($small-desktop) {
    left: calc(100% - 15px);
  }
}

.spring-enter-active,
.spring-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.spring-enter,
.spring-leave-active {
  opacity: 0;
}
</style>
